import {atom} from "recoil";
import {ProductCodeSelectFE} from "../api/types/productCode";
import {SelectElementModelFE} from "../api/types/generic";

export const productCodesAtom = atom<ProductCodeSelectFE[]>({
    key: "productCodesAtom",
    default: []
});

export const defaultSearchedLocationGroupProductCode = {locationGroup: "", productCode: "", legalEntities: []};
export const searchedLocationGroupProductCodeAtom = atom<{
    locationGroup: string
    productCode: string
    legalEntities: string[] | SelectElementModelFE | string
}>({
    key: "searchedLocationGroupProductCodeAtom",
    default: defaultSearchedLocationGroupProductCode
});
